import { render, staticRenderFns } from "./Logs2.vue?vue&type=template&id=5a0bbe9d"
import script from "./Logs2.vue?vue&type=script&lang=js"
export * from "./Logs2.vue?vue&type=script&lang=js"
import style0 from "./Logs2.vue?vue&type=style&index=0&id=5a0bbe9d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports